import { Component, OnInit, OnDestroy } from '@angular/core';
import { ViewsService } from '@app/services/views.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '@scaffold/services/course.service';
import { Subscription, Observable, Subject } from 'rxjs';
import { ChildLoadingService } from '@app/services/child-loading.service';
import { UndoService } from '@scaffold/services/undo.service';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { PendingChangesGuard } from '../../../shared/pending-changes.guard';
import { SaveDialogComponent } from '../../../generic/save-dialog/save-dialog.component';
import { PropertiesService } from '../../services/properties.service';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';
import { TranslationService } from '@services/translation.service';
import { PageTitleService } from '@services/page-title.service';
import { LoadingPageScreenService } from '@services/loading-page-screen.service';

@Component({
    selector: 'app-edit-frame',
    templateUrl: './edit-frame.component.html',
    styleUrls: ['./edit-frame.component.scss'],
    standalone: false
})
export class EditFrameComponent
  implements OnInit, PendingChangesGuard, OnDestroy
{
  subscription: Subscription;
  type: string = '';
  id: any;
  course;
  edit_form;
  view;
  _content;
  set content(value) {
    console.log('set content', value);
    this._content = [...value];
  }
  get content() {
    return this._content;
  }
  undoService: UndoService;
  isSaving = false;
  preventSaveDialog = false;
  constructor(
    private courseService: CourseService,
    public viewService: ViewsService,
    private route: ActivatedRoute,
    public router: Router,
    public loading: ChildLoadingService,
    public movingItem: MoveItemService,
    private dialog: ScaffoldDialogService,
    private pageTitleService: PageTitleService,
    private properties: PropertiesService,
    private translationService: TranslationService,
    private loadingPageScreenService: LoadingPageScreenService
  ) {}

  canDeactivate(): Observable<boolean> | boolean {
    if (this.preventSaveDialog) {
      return true;
    } else {
      console.log('Open Dilaog');
      let choice: Subject<boolean> = new Subject<boolean>();
      let settings: any = {
        context: {
          data: {
            title: this.translationService.getTranslatedContent(
              'unsaved_changes',
              'Unsaved Changes'
            ),
            message: this.translationService.getTranslatedContent(
              'there_may_be_unsaved_changes_in_this_view_lingo',
              'There may be unsaved changes in this view, Would you like to save?'
            ),
          },
        },
      };
      var dialogRef = this.dialog.open(SaveDialogComponent, settings);

      dialogRef.onClose.subscribe(result => {
        console.log(result);
        if (result) {
          if (result === 'save') {
            if (this.view.id) {
              this.isSaving = true;
              this.properties.setProperties(null);
              this.viewService.saveForm(this.view).subscribe(s => {
                this.isSaving = false;
                choice.next(true);
              });
            } else {
              choice.next(true);
            }
          } else {
            console.log(result);
            choice.next(true);
          }
        } else {
          choice.next(false);
          this.loadingPageScreenService.stopLoading();
        }
      });
      return choice;
    }
  }

  ngOnInit() {
    this.undoService = new UndoService();
    this.route.paramMap.subscribe(p => {
      this.id = p.get('id');
      this.type = p.get('type');
      this.loading.startLoading();
      if (!this.id) {
        this.route.parent.params.subscribe(parent => {
          this.viewService
            .getViews(
              '/' + parent.type + '/' + parent.id + '?mode=' + p.get('type')
            )
            .subscribe(ed => {
              if (ed[0]) {
                ed = ed[0];
              }
              this.viewService
                .getViews('/views/' + (ed.view_id || ed.id))
                .subscribe(co => {
                  if (co[0]) {
                    co = co[0];
                  }
                  if (co) {
                    if (!co.data) co.data = {};
                    if (!co.data.content) co.data.content = [];
                  }
                  this.setTitle(co.type + ': ' + co.mode);
                  this.view = co;
                  this.content = co.data.content;
                  this.undoService.setup(this.view.data, 'content');
                  console.log(this.view.data);
                  this.loading.endLoading();
                });
            });
        });
      } else {
        console.log(this.router);
        this.viewService
          .getViews(
            this.router.url.split('?')[0].replace(/\/edit/, '') +
              '?mode=' +
              (this.id ? 'read' : 'list')
          )
          .subscribe(ed => {
            if (ed[0]) {
              ed = ed[0];
            }
            this.viewService
              .getViews('/views/' + (ed.view_id || ed.id))
              .subscribe(co => {
                if (co[0]) {
                  co = co[0];
                }
                if (co) {
                  if (!co.data) co.data = {};
                  if (!co.data.content) co.data.content = [];
                }
                this.view = co;
                this.content = co.data.content;
                this.setTitle(co.type + ': ' + co.mode);
                this.undoService.setup(this.view.data, 'content');
                console.log(this.view.data);
                this.loading.endLoading();
              });
          });
      }
    });
  }

  savePage() {
    console.log(this.view);
    if (this.view.id) {
      this.view.data.content = this.content;
      this.isSaving = true;
      this.properties.setProperties(null);
      console.log(this.view);
      this.viewService.saveForm(this.view).subscribe(s => {
        console.log(s);
        this.preventSaveDialog = true;
        this.isSaving = false;

        let navRoute = '../';
        if (s.length > 0 && s[0].id) {
          navRoute += '../' + s[0].id;
        }

        this.router.navigate([navRoute], { relativeTo: this.route });
      });
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    if (this.subscription && this.subscription.unsubscribe)
      this.subscription.unsubscribe();
  }

  cancel() {
    let settings: any = {
      context: {
        data: {
          title: this.translationService.getTranslatedContent(
            'cancel_changes',
            'Cancel changes?'
          ),
          message: this.translationService.getTranslatedContent(
            'are_you_sure_you_want_to_cancel_lingo',
            'Are you sure you want to cancel? You will lose all unsaved progress made on this page.'
          ),
        },
      },
    };
    var dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.preventSaveDialog = true;
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }

  public setTitle(newTitle: string) {
    this.pageTitleService.section = newTitle || '';
  }
}
